import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export default function Header() {
    const [nameWidth, setNameWidth] = useState(() => getWidth());
    const [titleWidth, setTitleWidth] = useState(() => getTitleWidth());
    const [navWidth, setNavWidth] = useState(() => getNav());

    const style = {
        headerdiv: {
            height: "18vh",
            backgroundColor: "#0b486b",
            width: "100%",
            color: "white",
            display: "flex",
            flexDirection: "row",
            margin: "0",
            padding: "0"
        },
        headerleft: {
            display: "flex",
            flexDirection: "column",
            width: "45%",
            justifyContent: "left",
            alignItems: "left"
        },
        headerleftcontainer: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "left",
            alignItems: "left"
        },
        headerright: {
            display: "flex",
            width: "55%",
            backgroundColor: "#0b486b",
            justifyContent: "flex-end",
            alignItems: "flex-end",
            padding: "0 10px 10px 0"
        },
        nameplate: {
            display: "inline-block",
            fontSize: nameWidth,
            textAlign: "left",
            margin: "4px 0 0 14px",
            fontFamily: "'Sen', sans-serif",
            alignItems: "flex-end",
            color: "white",
            textDecoration: "none"
        },
        title: {
            display: "inline-block",
            textDecoration: "none",
            fontSize: titleWidth,
            textAlign: "left",
            margin: "0 0 0 18px",
            fontFamily: "'Sen', sans-serif",
            color: "white"
        },
        navitem: {
            display: "inline-block",
            margin: "5px 10px",
            textDecoration: "none",
            color: "white",
            fontFamily: "'Sen', sans-serif",
            fontSize: navWidth,
            fontWeight: "bold"
        },
        textd: {
            textDecoration: "none"
        }
    }

    function getWidth() {
        return window.innerWidth < 800 ? "24px" : "60px";
    }

    function getTitleWidth() {
        return window.innerWidth < 800 ? "16px" : "22px";
    }

    function getNav() {
        return window.innerWidth < 475 ? "16px" : "22px";
    }

    function windowSize() {
        console.log(window.innerWidth)
        if (window.innerWidth < 800) {
            setNameWidth("30px");
            setTitleWidth("16px")
        } else {
            setNameWidth("56px");
            setTitleWidth("20px")
        }
    }

    window.addEventListener('resize', windowSize)

    return (
        <div style={style.headerdiv}>
            <div style={style.headerleft}>
                <NavLink to='/' span style={style.textd}>
                    <div style={style.headerleftcontainer}>
                        <div style={style.nameplate}>Michael Ip</div>
                        <div style={style.title}>Software Engineer</div>
                    </div>
                </NavLink>
            </div>
            <div style={style.headerright}>
                <NavLink to='/portfolio' activeClassName="navactive">
                    <span style={style.navitem}>
                        Portfolio
                        </span>
                </NavLink>
                <NavLink to='/skills' activeClassName="navactive">
                    <span style={style.navitem} >
                        Skills
                    </span>
                </NavLink>
                <NavLink to='/about' activeClassName="navactive">
                    <span style={style.navitem}>
                        About
                    </span>
                </NavLink>
                <NavLink to='/links' activeClassName="navactive">
                    <span style={style.navitem}>
                        Links
                    </span>
                </NavLink>
                <NavLink to='/contact' activeClassName="navactive">
                    <span style={style.navitem}>
                        Contact
                    </span>
                </NavLink>
            </div>
        </div>
    )
}